(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const isTouchNavigation = !supportsHover || navigator.maxTouchPoints > 0;

    const toggleHoverDetails = (detailsSelector) => {
      const detailItems = document.querySelectorAll(detailsSelector);

      detailItems.forEach((details) => {
        let timeout;

        const summary = details.querySelector('summary');
        const hasDropdownContent = Boolean(summary && summary.nextElementSibling);

        if (summary) {
          summary.addEventListener('click', (e) => {
            const url = summary.getAttribute('data-url');

            if (!url) return;

            if (isTouchNavigation && hasDropdownContent && !details.hasAttribute('open')) {
              e.preventDefault();
              details.setAttribute('open', true);
              return;
            }

            e.preventDefault();
            window.location.href = url;
          });
        }

        if (supportsHover) {
          details.addEventListener('mouseenter', () => {
            clearTimeout(timeout);
            details.setAttribute('open', true);
          });

          details.addEventListener('mouseleave', () => {
            timeout = setTimeout(() => {
              // Add closing class for fade-out transition
              details.classList.add('mega-menu--closing');

              // Remove open attribute after transition completes
              setTimeout(() => {
                details.removeAttribute('open');
                details.classList.remove('mega-menu--closing');
              }, 300); // Match CSS transition duration
            }, 500);
          });
        }
      });
    };

    toggleHoverDetails('.menu-toggle-selector'); // Top-level
    toggleHoverDetails('.mega-menu-sub'); // Second-level
  });
  } catch(e) { console.error(e); }
})();

})();
